interface IssueState {
  errors: unknown[]
  fieldMeta: Record<string, { errors?: unknown[] } | undefined>
}

function messageOf(error: unknown): string | null {
  if (!error) return null
  if (typeof error === 'string') return error
  if (typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
    return error.message
  }
  return String(error)
}

/** The field a nested path belongs to: `occurrences[2].endTime` is part of `occurrences`. */
export function rootFieldOf(fieldName: string): string {
  return fieldName.replace(/\[\d+\].*$/, '').replace(/^(tags|price)\..*$/, '$1')
}

/**
 * What still blocks saving, one line per problem in the order the fields were registered:
 * the field's name where it is known, then the reason. Repeated lines are dropped.
 */
export function formIssues(
  state: IssueState,
  labelFor: (field: string) => string | undefined,
): string[] {
  const issues: string[] = []
  for (const error of state.errors) {
    const message = messageOf(error)
    if (message) issues.push(message)
  }
  for (const [fieldName, meta] of Object.entries(state.fieldMeta)) {
    const message = messageOf(meta?.errors?.find(Boolean))
    if (!message) continue
    const label = labelFor(fieldName) ?? labelFor(rootFieldOf(fieldName))
    issues.push(label && !message.startsWith(label) ? `${label}: ${message}` : message)
  }
  return [...new Set(issues)]
}
